import React from 'react';
import { Link } from 'react-router-dom';
import './Correction.css';

const Correction = () => {
  return (
    <div className="correction">
      {/* Hero Section */}
      <section className="correction-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1 className="page-title">경정청구</h1>
            <h2 className="main-quote">
              이미 낸 세금, 다시 검토해보세요
            </h2>
            <p className="description">
              과다납부된 세금을 되찾아드리는 <strong>성공보수제</strong> 서비스입니다
            </p>
          </div>
        </div>
      </section>

      {/* 경정청구란? */}
      <section className="what-is-correction">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">경정청구란?</h2>
            <p className="section-description">
              과다납부된 세금이 있을 때<br />
              <strong>세무서에 환급을 요청</strong>하는 제도입니다.
            </p>
          </div>
          
          <div className="correction-benefits fade-in-up">
            <div className="benefit-card">
              <div className="benefit-icon">💰</div>
              <h3>과다납부 세금 환급</h3>
              <p>잘못 계산되어 더 낸 세금을<br />되돌려받을 수 있습니다</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">📋</div>
              <h3>누락된 공제 적용</h3>
              <p>신고시 놓친 각종 공제나<br />감면을 적용할 수 있습니다</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">⚖️</div>
              <h3>법적 권리 행사</h3>
              <p>납세자의 정당한 권리를<br />법적 절차에 따라 행사합니다</p>
            </div>
          </div>
        </div>
      </section>

      {/* 경정청구 대상 */}
      <section className="correction-targets">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">경정청구 가능한 경우</h2>
          </div>
          
          <div className="targets-grid fade-in-up">
            <div className="target-category">
              <h3>양도소득세</h3>
              <ul>
                <li>과세물건 양도시 경비, 부대비용 누락</li>
                <li>재건축물건 계산 오류</li>
                <li>종중재산 처분시 납부할 세금 오류</li>
                <li>세액감면·공제 항목 오류</li>
              </ul>
            </div>

            <div className="target-category">
              <h3>종합소득세</h3>
              <ul>
                <li>사업소득 핵심필요경비 누락</li>
                <li>의료비, 교육비 공제 누락</li>
                <li>기부금 공제 미적용</li>
                <li>신용카드 등 소득공제 누락</li>
              </ul>
            </div>

            <div className="target-category">
              <h3>법인세</h3>
              <ul>
                <li>각종 세액공제 누락</li>
                <li>법정 손금 산입 항목 누락</li>
                <li>창업, 신기술관련 감면·공제 미적용</li>
                <li>고용증대세액공제 오류</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 경정청구 절차 */}
      <section className="correction-process">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">경정청구 진행 절차</h2>
            <p className="section-description">체계적인 절차로 확실한 결과를 보장합니다</p>
          </div>
          
          <div className="process-steps fade-in-up">
            <div className="step">
              <div className="step-number">1</div>
              <h3>무료 상담</h3>
              <p>기존 신고내역 검토 및<br />경정청구 가능성 진단</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>정밀 분석</h3>
              <p>세무 전문가의 상세한<br />세법 검토 및 계산</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>서류 작성</h3>
              <p>경정청구서 및<br />증빙서류 완벽 준비</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>세무서 제출</h3>
              <p>관할 세무서에<br />경정청구 접수</p>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <h3>결과 확인</h3>
              <p>경정통지서 수령 및<br />환급금 입금 확인</p>
            </div>
          </div>
        </div>
      </section>

      {/* 수수료 안내 */}
      <section className="correction-fee">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">성공보수제 수수료</h2>
            <p className="section-description">성공했을 때만 수수료를 받는 <strong>No Cure, No Pay</strong> 방식</p>
          </div>
          
          <div className="fee-structure fade-in-up">
            <div className="fee-card main-fee">
              <h3>경정청구 성공보수</h3>
              <div className="fee-amount">환급세액의<br /><span className="highlight">5% ~ 25%</span></div>
              <ul className="fee-features">
                <li>✅ 성공 시에만 수수료 지불</li>
                <li>✅ 사전 비용 부담 없음</li>
                <li>✅ 투명한 수수료 구조</li>
              </ul>
            </div>
            
            <div className="fee-details">
              <h4>수수료 구간별 안내</h4>
              <div className="fee-tiers">
                <div className="tier">
                  <span className="tier-range">환급액 1천만원 미만</span>
                  <span className="tier-rate">25%</span>
                </div>
                <div className="tier">
                  <span className="tier-range">환급액 1천만원 ~ 5천만원</span>
                  <span className="tier-rate">20%</span>
                </div>
                <div className="tier">
                  <span className="tier-range">환급액 5천만원 ~ 1억원</span>
                  <span className="tier-rate">15%</span>
                </div>
                <div className="tier">
                  <span className="tier-range">환급액 1억원 초과</span>
                  <span className="tier-rate">10%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 경정청구 기한 */}
      <section className="correction-deadline">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">⏰ 경정청구 신청 기한</h2>
            <p className="section-description warning">시간이 지나면 신청할 수 없으니 빠른 상담을 받으세요!</p>
          </div>
          
          <div className="deadline-info fade-in-up">
            <div className="deadline-card urgent">
              <h3>법정 신청기한</h3>
              <div className="deadline-time">신고기한으로부터<br /><strong>5년 이내</strong></div>
            </div>
            
            <div className="deadline-examples">
              <h4>세목별 경정청구 기한 예시</h4>
              <ul>
                <li><strong>2020년 귀속 양도소득세</strong> → 2026년 5월 31일까지</li>
                <li><strong>2020년 귀속 종합소득세</strong> → 2026년 5월 31일까지</li>
                <li><strong>2020년 귀속 법인세(12월 결산법인)</strong> → 2026년 3월 31일까지</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="correction-faq">
        <div className="container">
          <div className="section-content fade-in-up">
            <h2 className="section-title">자주 묻는 질문</h2>
          </div>
          
          <div className="faq-list fade-in-up">
            <div className="faq-item">
              <h4>Q. 경정청구를 했는데 거부당하면 어떻게 하나요?</h4>
              <p>A. 경정거부 통지를 받은 경우, 기한 내 조세불복이 가능합니다. 가능하다고 판단되면 끝을 보겠습니다.</p>
            </div>
            <div className="faq-item">
              <h4>Q. 세무조사나 불이익은 없나요?</h4>
              <p>A. 경정청구는 납세자의 정당한 권리입니다. 경정청구를 이유로 세무조사를 받지는 않습니다.</p>
            </div>
            <div className="faq-item">
              <h4>Q. 환급받는데 얼마나 걸리나요?</h4>
              <p>A. 통상 경정청구 접수 후 2~3개월 내에 처리됩니다.</p>
            </div>
            <div className="faq-item">
              <h4>Q. 다른 세무사가 신고한 건도 경정청구 가능한가요?</h4>
              <p>A. 네, 가능합니다. 어느 세무사가 신고했든 상관없이 경정청구를 진행할 수 있습니다.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="correction-cta">
        <div className="container">
          <div className="cta-content fade-in-up">
            <h2 className="cta-title">문의는 연중 가능합니다</h2>
            <p className="cta-description">
              상담을 통해 전후 사정과 포인트를 확인하겠습니다
            </p>
            
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">무료 상담 신청</Link>
              <a href="tel:02-6949-5003" className="btn btn-secondary">📞 02-6949-5003</a>
            </div>
            
            <p className="cta-note">
              💡 상담은 무료이며, 경정청구 가능성 진단까지 무료로 진행됩니다
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Correction;
